import axios from "axios"
import { getHeaders } from "services/AuthHeader";
import { Lesson } from "types/Lesson";
import { ReservationI } from "types/ReservationsI"
import { ReservationResponse } from "types/responses/ReservationResponse";
import { ResponseError } from "types/responses/ResponseError"
const API_URL = process.env.REACT_APP_API_URL;

export async function getLessons(
    page: number,
    selectedDate: Date,
    selectedInstructor: number,
    selectedLessonFilter: number) {
    // console.log("getLessons");
    // console.log(page);
    // console.log(selectedDate);
    // console.log(selectedInstructor);
    // console.log(selectedLessonFilter);


    try {
        const response = await axios.post(
            API_URL + '/lessons',
            {
                params: {
                    page: page,
                    date: selectedDate.getFullYear() + "-" + (selectedDate.getUTCMonth() + 1) + "-" + selectedDate.getUTCDate(),
                    coach: selectedInstructor == -1 ? null : selectedInstructor,
                    name: selectedLessonFilter == -1 ? null : selectedLessonFilter,
                }
            },{
                headers: getHeaders()
            }
        )

        // console.log("get Lessons:".toUpperCase(), response.data.lessons);


        if (!('lessons' in response.data)) {
            throw Error
        }
        if ('error' in response.data) {
            return response.data.error
        }

        const ret = new Array<Lesson>()
        response.data.lessons.forEach((lesson: any) => {
            ret.push(Lesson.instance(lesson))
        });

        if (ret.length === 0) {
            return {
                page: response.data.page,
                lessons: "no_data"
            }
        }

        return {
            page: response.data.page,
            lessons: ret
        };

    } catch (error) {
        //console.log(error);

        return ResponseError.general_error
    }

}

export async function getFilters() {
    try {
        const response = await axios.post(
            API_URL + '/lessons_filters',
            {
            },{
                headers: getHeaders()
            }
        )
        // console.log("lessonFilters service".toUpperCase());

        // console.log(response.data);

        return response.data;
    } catch (error) {
        //console.log(error);
        return ResponseError.general_error
    }
}

export async function lessonCreateReservation(id_lesson: number, language: any) {
    try {
        const response = await axios.post(
            API_URL + '/lessons_create_reservation',
            {
                params: {
                    id_lesson: id_lesson,
                    language,
                }
            },{
                headers: getHeaders()
            }
        )

        return response.data;
    } catch (error) {
        //console.log(error);
        return {error: ResponseError.general_error}
    }
}

export async function lessonCancelReservationService(id_lesson: number) {
    try {
        const response = await axios.post(
            API_URL + '/lessons_cancel_reservation',
            {
                params: {
                    id_lesson: id_lesson
                }
            },{
                headers: getHeaders()
            }
        )

        // console.log("lesson Cancel Reservation Service:".toUpperCase(), response.data);

        return response.data;
    } catch (error) {
        return {error: ResponseError.general_error}
    }
}
